export default __webpack_public_path__ + "static/media/SphereCoreTime.8656b6bd.webp";